<script lang="ts">

    import { Col, Container, Icon, Row, Table } from "sveltestrap";
    import AppWrapper from "../components/AppWrapper.svelte";
    import DateString from "../components/DateString.svelte";
    import FormName from "../components/FormName.svelte";
    import InstanceMembers from "../components/InstanceMembers.svelte";
    import InstanceAnswers from "../components/Instances/InstanceAnswers.svelte";
    import SignImage from "../components/Signs/SignImage.svelte";
    import UserName from "../components/UserName.svelte";
    import { SERVICE_URL } from "../evironment";
    import type { FormInstance } from "../global";
    import { instancesService } from "../services";

    export let instanceId: string;

    let instance: FormInstance;
    let loadComplete = false;

    $: updateInstance(instanceId);

    async function updateInstance(instanceId: string): Promise<void> {
        try {
            loadComplete = false;
            instance = await instancesService.getInstance(instanceId);
            loadComplete = true;
        } catch (error) {
            console.error(error);
        }
    }

</script>


<AppWrapper>
    {#if loadComplete}
        <Container fluid>
            <Row>
                <Col xs="12">
                    <div class="d-flex justify-content-between gap-3">
                        <h3 class="mb-4"><FormName formId={instance.formId} /></h3>
                        <a href="{SERVICE_URL}/instance/{instance.id}/pdf?markAsDownloaded=1" target="_blank" class="download-link">
                            <Icon name="download" />
                        </a>
                    </div>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <td>Fecha formulario</td>
                                <td>
                                    <DateString date={instance.dateCompleted} />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row class="mb-3">
                <Col xs="12">
                    <h6 class="mb-3">Miembros</h6>
                    <InstanceMembers members={instance.members} />
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <h6 class="mb-3">Respuestas</h6>
                    <InstanceAnswers {instance} />
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <h6 class="mb-3">Firmas</h6>
                    <div class="member-signs">
                        {#each instance.members as { userId, signId }}
                            <div class="sign">
                                <div class="name">
                                    <UserName {userId} />
                                </div>
                                <SignImage {signId} />
                            </div>
                        {/each}
                    </div>
                </Col>
            </Row>
        </Container>
    {/if}
</AppWrapper>

<style lang="scss">

    @use 'sass:math';

    .member-signs {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .sign {
        border: 1px solid #ccc;
        width: 200px;
        height: 170px;
        overflow: hidden;

        .name {
            padding: 0.5rem;
        }
    }

    @media print {
        
        :global(.app-wrapper) {
            display: block !important;
            height: auto !important;
        }

        :global(.sidebar),
        :global(.topbar) {
            display: none !important;
        }

        .sign {
            $width: 45mm; 
            width: $width;
            height: #{$width * math.div(170, 200)};
        }

        .download-link {
            display: none;
        }

    }

</style>
